class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("userLM"));
    return user?.refresh;
  }
  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("userLM"));
    return user?.access;
  }
  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("userLM"));
    user.access = token;
    localStorage.setItem("userLM", JSON.stringify(user));
  }
  updateLocalRefreshToken(token) {
    let user = JSON.parse(localStorage.getItem("userLM"));
    user.refresh = token;
    localStorage.setItem("userLM", JSON.stringify(user));
  }
  getUser() {
    return JSON.parse(localStorage.getItem("userLM"));
  }
  setUser(user) {
    localStorage.setItem("userLM", JSON.stringify(user));
  }
  removeUser() {
    localStorage.removeItem("userLM");
  }
}
export default new TokenService();
